import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from "@ngx-translate/core";
import { LaddaModule } from 'angular2-ladda';
import { NgbDropdownModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { MarketingMainComponent } from './containers';
import {
  OfferLinkComponent,
  CouponMetadataFormComponent,
  GenerateLinkFormComponent,
  AddMetadataExplainationPopupComponent
} from './components';

import { MarketingRoutingModule } from './marketing-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CopyFeedbackPopupComponent } from 'src/app/shared/components/copy-feedback-popup/copy-feedback-popup.component';

const COMPONENTS = [
  MarketingMainComponent,
  OfferLinkComponent,
  CouponMetadataFormComponent,
  GenerateLinkFormComponent,
  AddMetadataExplainationPopupComponent
]

@NgModule({
    declarations: [COMPONENTS],
    imports: [
        MarketingRoutingModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbDropdownModule,
        NgbPopoverModule,
        SharedModule,
        TranslateModule.forChild(),
        LaddaModule.forRoot({
            spinnerColor: 'grey',
            style: 'zoom-in'
        })
    ]
})
export class MarketingModule { }
